module.exports = __webpack_public_path__ + "static/media/7_Mang_juan.3d63ee93.png";